import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CategoryPage = lazy(() => import('../pages/category/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const PaymentSuccessPage = lazy(() => import('../pages/payment-success/page'));
const AccountPage = lazy(() => import('../pages/account/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const OnBilgilendirmeFormuPage = lazy(() => import('../pages/on-bilgilendirme-formu/page'));
const MesafeliSatisSozlesmesiPage = lazy(() => import('../pages/mesafeli-satis-sozlesmesi/page'));
const CerezPolitikasiPage = lazy(() => import('../pages/cerez-politikasi/page'));
const KVKKAydinlatmaMetniPage = lazy(() => import('../pages/kvkk-aydinlatma-metni/page'));
const KullanimKosullariPage = lazy(() => import('../pages/kullanim-kosullari/page'));
const UyelikVeKullanimSartlariPage = lazy(() => import('../pages/uyelik-ve-kullanim-sartlari/page'));
const IadePolitikasiPage = lazy(() => import('../pages/iade-politikasi/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kategori',
    element: <CategoryPage />,
  },
  {
    path: '/urun/:id',
    element: <ProductPage />,
  },
  {
    path: '/sepet',
    element: <CartPage />,
  },
  {
    path: '/odeme',
    element: <CheckoutPage />,
  },
  {
    path: '/odeme-basarili',
    element: <PaymentSuccessPage />,
  },
  {
    path: '/hesap',
    element: <AccountPage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/sss',
    element: <FAQPage />,
  },
  {
    path: '/on-bilgilendirme-formu',
    element: <OnBilgilendirmeFormuPage />,
  },
  {
    path: '/mesafeli-satis-sozlesmesi',
    element: <MesafeliSatisSozlesmesiPage />,
  },
  {
    path: '/cerez-politikasi',
    element: <CerezPolitikasiPage />,
  },
  {
    path: '/kvkk-aydinlatma-metni',
    element: <KVKKAydinlatmaMetniPage />,
  },
  {
    path: '/kullanim-kosullari',
    element: <KullanimKosullariPage />,
  },
  {
    path: '/uyelik-ve-kullanim-sartlari',
    element: <UyelikVeKullanimSartlariPage />,
  },
  {
    path: '/iade-politikasi',
    element: <IadePolitikasiPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
